// @flow
import { handleActions } from 'redux-actions';
import type { ActionType } from 'redux-actions';
import types from './types';
import typeof { fetchDataSuccess } from './actions';

export type State = {
    data: Array<number>,
    fetching: boolean,
    metadata: Object,
};

export const init: State = {
    data: [],
    fetching: true,
    metadata: {},
};

export default handleActions({
    [types.FETCH_DATA]: (state: State) => ({
        ...state,
        fetching: true,
    }),
    [types.FETCH_DATA_ERROR]: (state: State) => ({
        ...state,
        fetching: false,
    }),
    [types.FETCH_DATA_SUCCESS]: (state: State, action: ActionType<fetchDataSuccess>) => ({
        ...state,
        data: action.payload,
        fetching: false,
        metadata: action.meta,
    }),
}, init);
